import React, { useState } from 'react';
import './livesessions.css';
import doctorImg from '../../../assets/images/docter-live-session.png';
import doctorProfile from '../../../assets/images/docter-profile.png';

export const Livesessions = () => {
  const [email, setEmail] = useState('');

  return (
    <section className="live-sessions">
      <div className="live-sessions__content">
        <h2 className="live-sessions__title">Live Sessions – Coming Soon!</h2>
        <p className="live-sessions__subtitle">
          Our expert doctors will be going live soon to answer your questions and share
          valuable health insights. Stay tuned for the next session.
        </p>

        <p className="live-sessions__certified-label">Sessions are conducted by certified doctors</p>

        <div className="live-sessions__doctor-card">
          <img src={doctorProfile} alt="Doctor Malik" className="live-sessions__doctor-avatar" />
          <div className="live-sessions__doctor-info">
            <span className="live-sessions__doctor-name">By Doctor Malik</span>
            <span className="live-sessions__doctor-role">Senior Cardiologist, Apollo Hospitals</span>
            <div className="live-sessions__doctor-meta">
              <span className="live-sessions__meta-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
                20/12/2025
              </span>
              <span className="live-sessions__meta-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
                02:30 AM
              </span>
            </div>
          </div>
        </div>

        <div className="live-sessions__notify">
          <input
            type="email"
            className="live-sessions__email-input"
            placeholder="Write Your Email ID"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button className="live-sessions__notify-btn">Notify ME</button>
        </div>

        <p className="live-sessions__connect-label">sessions are stream click below to Connect</p>
        <button className="live-sessions__connect-btn">Connect Now</button>
      </div>

      <div className="live-sessions__illustration">
        <img src={doctorImg} alt="Live Session Doctor" className="live-sessions__doctor-img" />
      </div>
    </section>
  );
};
